<app-thi-page-shell [lang]="landingLang" *ngIf="article; else notFound">
  <div class="overflow-hidden">
    <section class="relative pt-40 pb-16 thi-section-gradient-soft overflow-hidden">
      <div class="container mx-auto px-4 relative z-10">
        <div class="max-w-3xl mx-auto">
          <a
            routerLink="/articles"
            class="inline-flex items-center gap-2 text-muted-foreground hover:text-foreground mb-8 transition-colors no-underline"
          >
            <i [ngClass]="arrowBackIcon" class="w-4 h-4" aria-hidden="true"></i>
            {{ t.resources.backToArticles }}
          </a>
          <div class="flex items-center gap-2 mb-4">
            <span
              class="flex items-center gap-1.5 bg-primary text-primary-foreground text-sm font-medium px-4 py-1.5 rounded-full"
            >
              <i [class]="categoryIconClass(article.category) + ' w-4 h-4'" aria-hidden="true"></i>
              {{ categoryLabel(article) }}
            </span>
          </div>
          <h1 class="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6 leading-tight">
            {{ article.title[landingLang] }}
          </h1>
          <p class="text-xl text-muted-foreground mb-6">{{ article.excerpt[landingLang] }}</p>
          <div class="flex flex-wrap items-center gap-4 text-muted-foreground">
            <div class="flex items-center gap-2">
              <i class="fa fa-calendar" aria-hidden="true"></i>
              <span>{{ article.date }}</span>
            </div>
            <div class="flex items-center gap-2">
              <i class="fa fa-clock-o" aria-hidden="true"></i>
              <span>{{ article.readTime }} {{ t.resources.minRead }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="bg-background">
      <div class="container mx-auto px-4">
        <div class="max-w-4xl mx-auto -mt-8">
          <div class="rounded-2xl overflow-hidden shadow-xl">
            <img
              [src]="article.image"
              [alt]="article.title[landingLang]"
              class="w-full h-64 md:h-96 object-cover"
            />
          </div>
        </div>
      </div>
    </section>

    <section class="py-16 bg-background">
      <div class="container mx-auto px-4">
        <div class="max-w-3xl mx-auto">
          <article class="thi-article-html" [innerHTML]="safeContent"></article>
        </div>

        <div
          class="max-w-3xl mx-auto mt-12 p-8 thi-surface-gradient-panel rounded-2xl text-center border border-border/40"
        >
          <h3 class="text-2xl font-bold text-foreground mb-4">{{ text('ctaTitle') }}</h3>
          <p class="text-muted-foreground mb-6">{{ text('ctaDesc') }}</p>
          <a routerLink="/register" class="thi-btn-primary-lg group inline-flex">
            {{ t.hero.ctaPrimary }}
            <i
              class="transition-transform group-hover:translate-x-1 rtl:group-hover:-translate-x-1"
              [ngClass]="arrowIcon"
            ></i>
          </a>
        </div>
      </div>
    </section>

    <section *ngIf="relatedArticles.length" class="py-16 bg-secondary/30">
      <div class="container mx-auto px-4">
        <div class="max-w-4xl mx-auto">
          <h2 class="text-2xl font-bold text-foreground mb-8 text-center">{{ text('related') }}</h2>
          <div class="grid md:grid-cols-2 gap-6">
            <a
              *ngFor="let r of relatedArticles"
              [routerLink]="['/articles', r.id]"
              class="group bg-card border border-border rounded-xl overflow-hidden hover:border-primary/30 transition-all hover:shadow-lg no-underline text-inherit block"
            >
              <div class="relative h-40 overflow-hidden">
                <img
                  [src]="r.image"
                  [alt]="r.title[landingLang]"
                  class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <div class="thi-article-card-fade" aria-hidden="true"></div>
                <div class="absolute bottom-3 start-3">
                  <span
                    class="flex items-center gap-1 bg-primary text-primary-foreground text-xs font-medium px-2 py-0.5 rounded-full"
                  >
                    <i [class]="categoryIconClass(r.category) + ' w-3 h-3'"></i>
                    {{ categoryLabel(r) }}
                  </span>
                </div>
              </div>
              <div class="p-4">
                <h3 class="font-bold text-foreground group-hover:text-primary transition-colors line-clamp-2">
                  {{ r.title[landingLang] }}
                </h3>
                <div class="flex items-center gap-2 text-xs text-muted-foreground mt-2">
                  <i class="fa fa-clock-o"></i>
                  {{ r.readTime }} {{ t.resources.minRead }}
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
</app-thi-page-shell>

<ng-template #notFound>
  <app-thi-page-shell [lang]="landingLang">
    <div class="min-h-[50vh] flex items-center justify-center px-4 py-24">
      <div class="text-center max-w-md">
        <h1 class="text-2xl font-bold text-foreground mb-4">{{ text('notFound') }}</h1>
        <a routerLink="/articles" class="thi-btn-primary-lg inline-flex">{{ t.resources.backToArticles }}</a>
      </div>
    </div>
  </app-thi-page-shell>
</ng-template>
